import { UpdateComponent } from './update/update.component';
import { ResultComponent } from './update/result/result.component';

export const MineChildRoutes = [
  {
    path: 'update',
    component: UpdateComponent,
  },
  {
    path: 'update/:ofuscatedData',
    component: ResultComponent,
  },
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: '/license/mine/update',
  },
];
